import { render, staticRenderFns } from "./SimulatedDispatchedOrder.vue?vue&type=template&id=482a508a&scoped=true"
import script from "./SimulatedDispatchedOrder.vue?vue&type=script&lang=js"
export * from "./SimulatedDispatchedOrder.vue?vue&type=script&lang=js"
import style0 from "./SimulatedDispatchedOrder.vue?vue&type=style&index=0&id=482a508a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482a508a",
  null
  
)

export default component.exports